import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { motion } from 'framer-motion'; // Importer Framer Motion pour les animations

const CardProjet = ({ projects }) => {
  // Variants pour l'animation à l'apparition
  const cardVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1 },
    hover: { scale: 1.05 }, // Zoom léger lorsqu'on passe la souris
  };

  return (
    <div className="d-flex flex-wrap justify-content-center">
      {projects.map((project, index) => (
        <motion.div
          key={project.Id_Projet}
          variants={cardVariants}
          initial="hidden"
          animate="visible"
          whileHover="hover" // Activer le zoom lors du hover
          transition={{ duration: 0.5, delay: index * 0.1 }} // Animation d'apparition avec un délai progressif
        >
          <Link
            to={`/projet/${project.Id_Projet}`} // Générer le lien avec l'ID du projet
            className="project-card m-3"
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <div className="team-item">
              <ul className="team-social">
                <li><a href="#!"><i className="bi bi-camera"></i></a></li>
                <li><a href="#!"><i className="bi bi-info-circle"></i></a></li>
                <li><a href="#!"><i className="bi bi-check-circle"></i></a></li>
                <li><a href="#!"><i className="bi bi-hand-thumbs-up"></i></a></li>
                {/* Ajout du lien mailto pour l'adresse e-mail du club */}
                <li>
                  <a
                    href={`mailto:${project.Mail_Club}`}
                    onClick={(e) => e.stopPropagation()} // Empêcher la propagation du clic vers le lien parent
                  >
                    <i className="bi bi-envelope"></i>
                  </a>
                </li>
              </ul>
              <img src={project.imageUrl || "https://via.placeholder.com/850x450"} alt={project.Nom_Projet} />
              <div className="team-info">
                <h5 style={{ color: 'white' }}>{project.Nom_Projet}</h5>
                <h6>Responsable: {project.Nom_Eleves} {project.Prenom_Eleves} {project.Classe_Eleves}</h6>
              </div>
            </div>
          </Link>
        </motion.div>
      ))}
    </div>
  );
};

export default CardProjet;

